import { render, staticRenderFns } from "./kpiIndicators.vue?vue&type=template&id=3ff57f28&scoped=true"
import script from "./kpiIndicators.vue?vue&type=script&lang=js"
export * from "./kpiIndicators.vue?vue&type=script&lang=js"
import style0 from "./kpiIndicators.vue?vue&type=style&index=0&id=3ff57f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff57f28",
  null
  
)

export default component.exports